import { RootState } from '../../store';

export const getDashboardTicketsSelector = (state: RootState) => state.dashboardReducer.tickets || [];
export const getDashboardDocumentsSelector = (state: RootState) => state.dashboardReducer.documents || [];
export const getIsLoadingSelector = (state: RootState) => state.dashboardReducer.isLoading || false;
